import { render, staticRenderFns } from "./kl8.vue?vue&type=template&id=a2d88a1e"
import script from "./kl8.vue?vue&type=script&lang=js"
export * from "./kl8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports